export default __webpack_public_path__ + "static/media/bg-ampoule.75b49871.svg";